import { render, staticRenderFns } from "./DoubtSecctionSuccessComponent.vue?vue&type=template&id=7264183f"
import script from "./DoubtSecctionSuccessComponent.vue?vue&type=script&lang=js"
export * from "./DoubtSecctionSuccessComponent.vue?vue&type=script&lang=js"
import style0 from "./DoubtSecctionSuccessComponent.vue?vue&type=style&index=0&id=7264183f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports